import { combineReducers, Reducer } from "redux";

import { reducer as formReducer } from "redux-form";

import { connectRouter } from "connected-react-router";
import history from "../history";

import appNotificationMessageReducer from "./app_notification_message_reducer";
import authReducer from "./auth_reducer";
import clientBillingReducer from "./client_billing_reducer";
import clientClientBookmarksReducer from "./client_client_bookmarks_reducer";
import clientClientBrowsingHistoriesReducer from "./client_client_browsing_histories_reducer";
import clientClientsReducer from "./client_clients_reducer";
import clientContractReducer from "./client_contract_reducer";
import clientContractListReducer from "./client_contracts_reducer";
import clientCustomerReducer from "./client_customer_reducer";
import clientDashboardReducer from "./client_dashboard_reducer";
import clientEntriesReducer from "./client_entries_reducer";
import clientMessageRoomReducer from "./client_message_room_reducer";
import clientMessageRoomsReducer from "./client_message_rooms_reducer";
import clientMypageReducer from "./client_mypage_reducer";
import clientPmCampaignReducer from "./client_pm_campaign_reducer";
import clientSalesCampaignReducer from "./client_sales_campaign_reducer";
import clientIpoCampaignReducer from "./client_ipo_campaign_reducer";
import clientProjectDetailReducer from "./client_project_reducer";
import clientProjectListReducer from "./client_projects_reducer";
import clientScoutCustomerReducer from "./client_scout_customer_reducer";
import clientScoutCustomerListReducer from "./client_scout_customers_reducer";
import clientTopPageReducer from "./client_top_page_reducer";
import customerBlackListReducer from "./customer_black_list_reducer";
import customerDashboardReducer from "./customer_dashboard_reducer";
import customerEntriesReducer from "./customer_entries_reducer";
import customerMessageRoomReducer from "./customer_message_room_reducer";
import customerMessageRoomsReducer from "./customer_message_rooms_reducer";
import customerMypageReducer from "./customer_mypage_reducer";
import customerProjectReducer from "./customer_project_reducer";
import customerProjectListReducer from "./customer_projects_reducer";
import customerTopPageReducer from "./customer_top_page_reducer";
import customerTutorialReducer from "./customer_tutorial_reducer";
import skillTagReducer from "./skill_tag_reducer";

const appReducer: Reducer<any> = combineReducers<any>({
  authReducer,
  appNotificationMessageReducer,
  customerDashboardReducer,
  customerTutorialReducer,
  customerTopPageReducer,
  customerEntriesReducer,
  customerMypageReducer,
  customerBlackListReducer,
  customerProjectListReducer,
  customerProjectReducer,
  customerMessageRoomsReducer,
  customerMessageRoomReducer,
  clientTopPageReducer,
  clientContractReducer,
  clientContractListReducer,
  clientMypageReducer,
  clientMessageRoomReducer,
  clientMessageRoomsReducer,
  clientProjectDetailReducer,
  clientProjectListReducer,
  clientDashboardReducer,
  clientEntriesReducer,
  clientCustomerReducer,
  clientScoutCustomerListReducer,
  clientScoutCustomerReducer,
  clientClientsReducer,
  clientClientBookmarksReducer,
  clientClientBrowsingHistoriesReducer,
  clientBillingReducer,
  clientPmCampaignReducer,
  clientSalesCampaignReducer,
  clientIpoCampaignReducer,
  skillTagReducer,
  form: formReducer,
  router: connectRouter(history),
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/app_reducer.ts